module.exports = __webpack_public_path__ + "static/img/ChronicDisseDetailsHead.e0aaa5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rightsDetails/chronicDisease/ChronicDisseDetailsHead.png
// module id = D21u
// module chunks = 55